const isBrowser = typeof window !== 'undefined'

export const REGISTER_PENDING_COOKIE = 'register-pending'

export const readRegisterPending = () => {
  if (!isBrowser) return null

  try {
    const raw = document.cookie
      .split(';')
      .map((part) => part.trim())
      .find((part) => part.startsWith(`${REGISTER_PENDING_COOKIE}=`))
    if (!raw) return null

    const parsed = JSON.parse(decodeURIComponent(raw.slice(REGISTER_PENDING_COOKIE.length + 1)))
    if (!parsed || typeof parsed !== 'object') return null
    if (typeof parsed.email !== 'string' || !parsed.email) return null

    return {
      email: parsed.email,
      userId: typeof parsed.userId === 'string' ? parsed.userId : '',
      domainStatus: typeof parsed.domainStatus === 'string' ? parsed.domainStatus : '',
      expectedInstitutional: parsed.expectedInstitutional === true
    }
  } catch {
    return null
  }
}

export const clearRegisterPending = () => {
  if (!isBrowser) return
  try {
    const secure = window.location.protocol === 'https:' ? '; Secure' : ''
    document.cookie = `${REGISTER_PENDING_COOKIE}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; Max-Age=0; path=/; SameSite=Lax${secure}`
  } catch {
    /* no-op */
  }
}
